
import axios from "axios";
import Config from "src/config";

const v2_actionCalendarioEditarEvento = (id, data) => {
    let content = {
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/calendario/eventos/${id}/editar`,
        data
    }
    console.log('content', content);
    return axios(content);
};
export default v2_actionCalendarioEditarEvento;
